<template>
  <div class="back">
    <crumb prevLevel="预警总览" :current="current" />
    <warning-list
      :warningList="warningList"
      :total="warningTotalCount"
      @current-change="loadWarnList"
    />
  </div>
</template>

<script>
import Crumb from 'components/crumb/crumb';
import WarningList from 'components/warning/list';

const map = {
  证照异常: 'zzyc',
  进销存异常: 'jxcyc',
  '生产存储异常&&仓储运输异常': 'ccysyc',
  原辅料异常: ' yflyc'
};

export default {
  data() {
    return {
      enterpriseName: '',
      warningList: [],
      warningTotalCount: 0
    };
  },
  created() {
    this.warnType = this.$route.query.warnType;
    this.enterpriseName = this.$route.query.enterpriseName;
    this.currentWeek = this.$route.query.currentWeek;
    this.currentYear = this.$route.query.currentYear;
    this.weekDate = this.$route.query.weekDate;
    this.loadWarnList();
  },
  computed: {
    current() {
      const startDate = new Date(
        new Date(this.weekDate).getTime() - 1000 * 60 * 60 * 24 * 7
      ).format('yyyy-MM-dd');

      if (this.enterpriseName) {
        return `${this.enterpriseName}预警列表（${startDate} ~ ${this.weekDate}）`;
      }
      return `${this.warnType}预警列表（${startDate} ~ ${this.weekDate}）`;
    }
  },
  methods: {
    loadWarnList(currentPage) {
      if (this.enterpriseName) {
        this.loadWarnListByName(currentPage);
      } else {
        this.loadWarnListByType(currentPage);
      }
    },
    loadWarnListByName(currentPage) {
      this.$request({
        url: 'rest/riskWarnStatistics/riskWarnEntSurveyStatistics',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: currentPage || 1,
              pageSize: 7
            },
            params: {
              currentWeek: this.currentWeek,
              currentYear: this.currentYear,
              enterpriseName: this.enterpriseName
            }
          })
        }
      }).then(res => {
        this.warningList = res.pageInfo.list;
        this.warningTotalCount = res.pageInfo.total;
      });
    },
    loadWarnListByType(currentPage) {
      this.$request({
        url: 'rest/riskWarnStatistics/riskWarnClassifyStatistics',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: currentPage || 1,
              pageSize: 7
            },
            params: {
              currentWeek: this.currentWeek,
              currentYear: this.currentYear,
              warnType: map[this.warnType]
            }
          })
        }
      }).then(res => {
        this.warningList = res.pageInfo.list;
        this.warningTotalCount = res.pageInfo.total;
      });
    }
  },
  components: {
    Crumb,
    WarningList
  }
};
</script>

<style lang="stylus" scoped>
.back
  padding 0 20px 15px 20px
  border-radius 4px
  background #fff
  color #000
  .search
    margin 30px 0
  >.title
    line-height 30px
    font-size 14px
  .statistic
    background #fff
    margin-top 20px
    overflow hidden
    color #000
    border-top 1px solid rgba(206,219,239,0.5)
    border-bottom 1px solid rgba(206,219,239, .5)
    margin-bottom 20px
    .body
      position relative
      overflow hidden
      .num-statics
        position relative
        width 50%
        float left
        .echarts-border
          position absolute
          width 1px
          background rgba(206,219,239,.5)
          left 504px
          top 190px
          height 320px
      .scale-statics
        width 50%
        float left
        .title
          padding-left 30px
      .border
        width 1px
        position absolute
        top 0
        left 50%
        bottom 0
        background rgba(206,219,239,.5)
      .title
        border-bottom 1px solid #CEDBEF
        padding 5px 0
        .text
          font-size 14px
          margin-bottom 5px
        .sub-text
          font-size 12px
          color #666666
      .num-list
        display flex
        justify-content center
        .num-item
          margin 0 20px
          text-align center
          padding-top 30px
          .num
            color #386CE2
            font-size 28px
          .text
            font-size 12px
</style>
